// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-page-container[data-v-2dde37ee]{text-align:center}@media(max-width:960px){.success-page-container .result-popup .action img[data-v-2dde37ee]{width:100%}}.success-page-container .result-popup p[data-v-2dde37ee]{margin-top:15px}.success-page-container .cta[data-v-2dde37ee]{width:271px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
